import { useEffect } from 'react';

import { useSnapshot } from 'valtio';

import { ScrollService } from 'services/ScrollService';
import { scrollState } from 'state/dom/scroll';

const useScroll = () => {
    const { top } = useSnapshot(scrollState);

    return {
        top,
        scroll: ScrollService.scroll,
    };
};

const useScrollSetter = () => {
    useEffect(() => {
        const tick = () => {
            scrollState.top = window.scrollY;

            window.requestAnimationFrame(tick);
        };

        window.requestAnimationFrame(tick);
    }, []);

    return null;
};

export { useScroll, useScrollSetter };
